document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-card").forEach((card) => {
    const currentSwatch = card.querySelectorAll(".block-swatch");
    const linkCard = card.querySelector(".product-card__media");

    currentSwatch.forEach((element) => {
      element.addEventListener("click", () => {
        setTimeout(() => {
          const wishlistBtn = card.querySelector(".th_prd_wl_btn");
          const href = linkCard.getAttribute("href");

          if (!href) return;

          const params = new URLSearchParams(href.split("?")[1]);
          const variantId = params.get("variant");

          if (variantId) {
            wishlistBtn.dataset.variant_id = variantId;
          }
        }, 100);
      });
    });
  });
});

/* PRODUCT PAGE DETAIL */
/* GESTIONE DESCRIZIONE LEGGI DI PIÙ */
const productDescription = document.querySelector(".js-product-description");
const productShowMore = document.querySelector(".js-show-more");
if (productDescription && productShowMore) {
  const labelMore = productShowMore.dataset.labelMore;
  const labelLess = productShowMore.dataset.labelLess;

  if (productDescription.scrollHeight <= productDescription.clientHeight) {
    productShowMore.style.display = "none";
  }
  productShowMore.addEventListener("click", () => {
    productDescription.classList.toggle("clamp-description");
    productShowMore.textContent = !productDescription.classList.contains(
      "clamp-description"
    )
      ? labelLess
      : labelMore;
  });
}

/* GESTIONE CUSTOM WRAP */
document.addEventListener("DOMContentLoaded", function () {
  const wrapSection = document.querySelector("#plg-wrap-position");
  const wrapContainer = document.querySelector("#plg-wrap-container");

  if (wrapSection && wrapContainer) {
    wrapSection.appendChild(wrapContainer);
    wrapContainer.style.display = "block";
  }

});

/* CART CUSTOM ATTRIBUTE - Salvataggio automatico (Fix Delegazione Eventi) */
document.addEventListener("DOMContentLoaded", function () {
  
  // Ascolta gli eventi globalmente sul document
  document.addEventListener("change", handleAttributeUpdate);
  document.addEventListener("input", debounce(handleAttributeUpdate, 500));

  function handleAttributeUpdate(event) {
    const target = event.target;
    // Verifica se l'input modificato è dentro un tag <cart-note> o ha il nome corretto
    if (!target.closest('cart-note') && !target.getAttribute("name")) return;
    
    const name = target.getAttribute("name");
    if (!name) return;

    // Puliamo il valore rimuovendo spazi bianchi extra all'inizio e alla fine
    const cleanedValue = target.value.trim();

    // Gestisce le note standard
    if (name === "note") {
      fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: cleanedValue }),
        keepalive: true,
      });
    }
    // Gestisce gli attributi personalizzati
    else if (name.startsWith("attributes[")) {
      const attributeName = name.match(/attributes\[(.*?)\]/)?.[1];

      if (attributeName) {
        const attributes = {};
        
        // FIX CRUCIALE: Se cleanedValue è vuoto, passiamo "", 
        // Shopify capisce che l'attributo va azzerato/rimosso nell'Admin.
        attributes[attributeName] = cleanedValue;

        fetch(`${Shopify.routes.root}cart/update.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes }),
          keepalive: true,
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Attributo salvato:", attributeName, cleanedValue);
            // Sincronizza tutti gli altri campi visivi (mantiene target.value originale per evitare problemi di focus mentre digita)
            syncAttributeFields(name, target.value, target);
          })
          .catch((error) => {
            console.error("Errore nel salvataggio:", error);
          });
      }
    }
  }

  function syncAttributeFields(attributeName, value, excludeElement) {
    const allFields = document.querySelectorAll(`[name="${attributeName}"]`);
    allFields.forEach((field) => {
      if (field !== excludeElement && field.value !== value) {
        field.value = value;
      }
    });
  }

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func.apply(this, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
});

document.addEventListener("DOMContentLoaded", () => {

  /* featured search */
const featuredSearch = document.querySelector(".js-featured-search");
if(featuredSearch) {
  
    const nextBtn = featuredSearch.querySelector('.prev-next-button--next')
    const prevBtn = featuredSearch.querySelector('.prev-next-button--prev')
  new Swiper(featuredSearch, {
    slidesPerView: 2,
    spaceBetween: 20,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    breakpoints: {
       1024: {
        slidesPerView: 5,
      },
  }
  });
}

});

function initFeaturedCartSwiper() {
  const featuredCart = document.querySelector(".js-featured-cart");

  if (!featuredCart || featuredCart.swiper) return;

  const nextBtn = featuredCart.querySelector(".prev-next-button--next");
  const prevBtn = featuredCart.querySelector(".prev-next-button--prev");

  new Swiper(featuredCart, {
    slidesPerView: 1,
    direction: "vertical",
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initFeaturedCartSwiper();

  const drawer = document.querySelector("#cart-drawer");

  if (drawer) {
    const observer = new MutationObserver(() => {
      initFeaturedCartSwiper();
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true,
    });
  }
});

document.addEventListener('variant:change', function(event) {
  const placeholder = document.querySelector('[data-wysh-product-button-placeholder]');

  if (!placeholder) return;

  if (event.detail.variant && event.detail.variant.available) {
    placeholder.style.display = '';
  } else {
    placeholder.style.display = 'none';
  }
});


function formatVariants() {
  document
    .querySelectorAll('#wysh-page .wysh-product-variant-list option')
    .forEach(option => {
      if (option.dataset.formatted) return;

      const text = option.textContent.trim();

      const cleaned = text.includes(' - ')
        ? text.split(' - ').slice(1).join(' - ')
        : text;

      const [color, size] = cleaned.split(' / ');

      const formattedColor = color
        .toLowerCase()
        .replace(/\b\w/g, c => c.toUpperCase());

      option.textContent = size
        ? `${formattedColor} / ${size.toUpperCase()}`
        : formattedColor;

      option.dataset.formatted = 'true';
    });
}

formatVariants();

// riesegue quando il widget aggiorna il DOM
const observer = new MutationObserver(formatVariants);

observer.observe(document.body, {
  childList: true,
  subtree: true
});

/* LOAD MORE */
document.addEventListener('DOMContentLoaded', function() {
  let observer;

  const initInfiniteScroll = () => {
    // Se c'è un observer attivo da una precedente esecuzione (es. cambio filtri), lo scolleghiamo
    if (observer) observer.disconnect();

    const trigger = document.querySelector('.infinite-scroll-trigger');
    const productList = document.querySelector('.product-list');
    
    if (!trigger || !productList) return;

    let isLoading = false;

    // Creiamo l'Intersection Observer
    observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // Quando il trigger entra nel viewport e non c'è già un caricamento in corso
        if (entry.isIntersecting && !isLoading) {
          const nextUrl = trigger.getAttribute('data-next-url');
          if (!nextUrl) return;

          isLoading = true;

          fetch(nextUrl)
            .then(response => response.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              
              // Selezioniamo i nuovi elementi della griglia dal documento fetchato
              const newProducts = doc.querySelectorAll('.product-list > *');
              
              newProducts.forEach(product => {
                // Troviamo il tag product-card (può essere l'elemento stesso o un suo figlio)
                const productCard = product.matches('product-card') ? product : product.querySelector('product-card');
                
                if (productCard) {
                  // Rimuoviamo l'attributo dell'animazione per fare in modo che il CSS del tema non lo nasconda
                  productCard.removeAttribute('reveal-on-scroll');
                  // Opzionale: forziamo l'opacità a 1 per sicurezza se il CSS globale lo avesse azzerato di base
                  productCard.style.opacity = '1';
                }
                
                // Appendiamo il prodotto alla griglia attuale
                productList.appendChild(product);
              });

              // Controlliamo se nel nuovo documento esiste un'ulteriore pagina successiva
              const nextTrigger = doc.querySelector('.infinite-scroll-trigger');
              
              if (nextTrigger) {
                const newUrl = nextTrigger.getAttribute('data-next-url');
                trigger.setAttribute('data-next-url', newUrl);
              } else {
                // Se non ci sono più pagine, eliminiamo il trigger e scolleghiamo l'observer
                trigger.remove();
                observer.disconnect();
              }
            })
            .catch(error => {
              console.error('Errore durante l\'infinite scroll:', error);
            })
            .finally(() => {
              isLoading = false;
            });
        }
      });
    }, {
      // Inizia a caricare quando il trigger si trova a 400px dal fondo dello schermo (UX più fluida)
      rootMargin: '0px 0px 400px 0px'
    });

    // Avvia l'osservazione sul trigger
    observer.observe(trigger);
  };

  // Esegui subito al caricamento della pagina
  initInfiniteScroll();

  // Intercettiamo l'evento AJAX di Shopify quando cambiano i filtri della collezione
  document.addEventListener('shopify:section:load', initInfiniteScroll);
});


/* NEW GIFT MESSAGE DRAWER */

const drawerGiftMessageProduct = document.querySelector('.js-gift-message-drawer');
const removeGiftMessageProduct = document.querySelector('.js-remove-gift-message-drawer');
const editGiftMessageProduct = document.querySelector('.js-edit-gift-message-drawer');

const saveGiftMessageProduct = document.querySelector('.js-save-gift-message');
const messaggioGiftMessageProductHidden = document.querySelector('#js-messaggio-biglietto-hidden');
const firmaGiftMessageProductHidden = document.querySelector('#js-nome-mittente-hidden');

const messaggioGiftMessageProduct = document.querySelector('#js-messaggio-biglietto');
const firmaGiftMessageProduct = document.querySelector('#js-nome-mittente');

// Memorizziamo i nomi originali dei name per poterli ripristinare all'occorrenza
const originalMessaggioName = messaggioGiftMessageProductHidden ? messaggioGiftMessageProductHidden.getAttribute('name') : '';
const originalFirmaName = firmaGiftMessageProductHidden ? firmaGiftMessageProductHidden.getAttribute('name') : '';

function updateGiftMessageButtonsVisibility() {
  const hasMessaggio = messaggioGiftMessageProductHidden && messaggioGiftMessageProductHidden.value.trim() !== '';
  const hasFirma = firmaGiftMessageProductHidden && firmaGiftMessageProductHidden.value.trim() !== '';
  const hasValue = hasMessaggio || hasFirma;

  if (editGiftMessageProduct) {
    editGiftMessageProduct.style.display = hasValue ? '' : 'none';
  }
  if (removeGiftMessageProduct) {
    removeGiftMessageProduct.style.display = hasValue ? '' : 'none';
  }

  // BILETTINO COMPILATO -> Attiva i campi hidden. VUOTO -> Disattivali per non inviarli a Shopify
  if (messaggioGiftMessageProductHidden) {
    if (messaggioGiftMessageProductHidden.value.trim() === '') {
      messaggioGiftMessageProductHidden.removeAttribute('name'); // Rimuovendo il name non viene inviato
    } else {
      messaggioGiftMessageProductHidden.setAttribute('name', originalMessaggioName);
    }
  }

  if (firmaGiftMessageProductHidden) {
    if (firmaGiftMessageProductHidden.value.trim() === '') {
      firmaGiftMessageProductHidden.removeAttribute('name');
    } else {
      firmaGiftMessageProductHidden.setAttribute('name', originalFirmaName);
    }
  }
}

// Stato iniziale al caricamento della pagina
updateGiftMessageButtonsVisibility();

if (drawerGiftMessageProduct) {
  // Utilizziamo la delegazione per i toggle del drawer per sicurezza
  document.addEventListener('click', (e) => {
    if (e.target.closest('.js-toggle-gift-message-drawer')) {
      const willBeVisible = !drawerGiftMessageProduct.classList.contains('is-visible');

      if (willBeVisible) {
        if (messaggioGiftMessageProduct && messaggioGiftMessageProductHidden) {
          messaggioGiftMessageProduct.value = messaggioGiftMessageProductHidden.value;
        }
        if (firmaGiftMessageProduct && firmaGiftMessageProductHidden) {
          firmaGiftMessageProduct.value = firmaGiftMessageProductHidden.value;
        }
      }

      drawerGiftMessageProduct.classList.toggle('is-visible');
    }
  });

  // Chiudi il drawer se clicco fuori dal .content
  drawerGiftMessageProduct.addEventListener('click', (e) => {
    if (e.target === drawerGiftMessageProduct) {
      drawerGiftMessageProduct.classList.remove('is-visible');
    }
  });
}

if (saveGiftMessageProduct && messaggioGiftMessageProduct && firmaGiftMessageProduct) {
  saveGiftMessageProduct.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation(); // FIX: Impedisce al listener globale sul document di scattare e riattivare il toggle

    if (messaggioGiftMessageProductHidden) {
      messaggioGiftMessageProductHidden.value = messaggioGiftMessageProduct.value.trim();
    }

    if (firmaGiftMessageProductHidden) {
      firmaGiftMessageProductHidden.value = firmaGiftMessageProduct.value.trim();
    }

    drawerGiftMessageProduct.classList.remove('is-visible');
    updateGiftMessageButtonsVisibility();
  });
}

if (removeGiftMessageProduct) {
  removeGiftMessageProduct.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation(); // FIX: Sicurezza aggiuntiva se il pulsante di rimozione dovesse avere classi di toggle
    
    if (messaggioGiftMessageProductHidden) messaggioGiftMessageProductHidden.value = '';
    if (firmaGiftMessageProductHidden) firmaGiftMessageProductHidden.value = '';
    if (messaggioGiftMessageProduct) messaggioGiftMessageProduct.value = '';
    if (firmaGiftMessageProduct) firmaGiftMessageProduct.value = '';
    
    updateGiftMessageButtonsVisibility();
  });
}


document.addEventListener('DOMContentLoaded', () => {
  
  // Utilizziamo la delegazione degli eventi sul document
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.js-plg-dialognote-trigger');
    if (trigger) {
      const panelNote = document.querySelector('.js-plg-dialognote-panel');
      if (panelNote) {
        panelNote.classList.toggle('isVisible');
      }
    }
  });

});



  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
